<template>
  <div class="company-notes">
    <div class="d-flex justify-content-between mb-3">
      <form method="get" @submit.prevent="doPaging(1)">
        <div class="d-flex align-items-center">
          <input type="text" class="form-control mr-2" v-model="keyword">
          <button class="btn btn-secondary">Search</button>&nbsp;
          <button class="btn btn-secondary" @click="doViewAll">All</button>
        </div>
      </form>
      <div class="d-flex align-items-center">
        <button type="button" class="btn btn-outline-black" @click="showModalAdd = true">
          + Add New</button>
      </div>
    </div>
    <div class="table-responsive" v-if="notes.length">
      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th>TITLE</th>
          <th>EXCERPT</th>
          <th>CREATOR</th>
          <th>LAST MODIFIED</th>
          <th width="100" class="text-right"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(note, index) in notes" :key="index">
          <td>
            <a class="black" href="javascript:;" @click="viewNote( index )">{{ note.title }}</a>
          </td>
          <td v-html="note.excerpt"></td>
          <td>{{ note.creator.full_name }}</td>
          <td>{{ note.updated_at | fromNow }}</td>
          <td align="right">
            <a href="javascript:;" class="icon-pencil mr-2" v-tooltip="'Edit Note'" @click="editNote( index )"></a>
            <a href="javascript:;" class="icon-trash" v-tooltip="'Delete Note'" @click="confDelete( index )"></a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="notes.length == 0" class="alert alert-warning">
      No notes found
    </div>

    <div class="d-flex justify-content-between">
      <div class="actions">
      </div>
      <pagination :total-pages="totalPages" :current-page="currentPage"
                  @goto-page="doPaging"></pagination>
    </div>

    <modal-add-note v-model="showModalAdd" :clientId="client_id" @note-created="onNoteAdded"></modal-add-note>
    <modal-edit-note v-model="showModalEdit" :clientId="client_id" :note="activeNote" @note-saved="onNoteSaved"></modal-edit-note>
    <modal-view-note v-model="showModalView" :note="activeNote"></modal-view-note>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import ServiceNote from '@/services/note'
  import ModalAddNote from './notes/ModalAddNote'
  import ModalEditNote from './notes/ModalEditNote'
  import ModalViewNote from './notes/ModalViewNote'

  export default {
    components: {
      ModalAddNote,
      ModalEditNote,
      ModalViewNote
    },
    data () {
      return {
        showModalAdd: false,
        showModalEdit: false,
        showModalView: false,
        state: 'loading',
        keyword: '',
        activeIndex: -1,
        currentPage: 1,
        totalPages: 0,
        notes: [],
        client_id: null
      };
    },
    computed: mapState({
      client: state => state.client.client,
      activeNote () {
        let self = this;
        return self.notes[self.activeIndex] ? self.notes[self.activeIndex] : null;
      },
      hasFilters () {
        let self = this;
        return self.keyword != '';
      },
    }),
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.getNotes();
        self.client_id = self.client.id;
        self.showModalAdd = false;
        self.showModalEdit = false;
        self.showModalView = false;
      },
      viewNote ( index ) {
        let self = this;
        self.activeIndex = index;
        self.showModalView = true;
      },
      editNote ( index ) {
        let self = this;
        self.activeIndex = index;
        self.showModalEdit = true;
      },
      onNoteSaved ( note ) {
        let self = this;
        self.notes.splice( self.activeIndex, 1, note );
      },
      onNoteAdded ( note ) {
        let self = this;
        self.notes.push( note );
      },
      confDelete ( index ) {
        let self = this, item = self.notes[index];
        self.$dialog
          .confirm('Are you sure you want to delete note <strong>' + item.title + '</strong>?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            ServiceNote.delete(item.id, () => {
              dialog.close();
              self.notes.splice(index, 1);
              self.$notify({
                type: 'success',
                text: 'Note <strong>' + item.title + '</strong> is deleted'
              });
            });
          })
          .catch(() => {})
        ;
      },
      doViewAll () {
        let self = this;
        self.currentPage = 1;
        self.keyword = '';
        self.getNotes();
      },
      doPaging ( page ) {
        let self = this;
        self.currentPage = page;
        self.getNotes();
      },
      getNotes () {
        let self = this,
          params = {
            page: self.currentPage,
          };

        if ( self.keyword !== '' ) {
          params.kw = self.keyword;
        }

        params.client_id = self.client.id;

        self.state = 'loading';
        ServiceNote.getNotes(params, resp => {
          self.state = 'loaded';
          self.notes = resp.data;
          self.totalPages = resp.last_page;
        });
      }
    }
  }
</script>
